import { useEffect } from 'react';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { Paragraph } from '../Ant';
import LanguageList from './languageList';
import RegionList from './regionList';
import { usePage } from '../../context/PageContext';
import { useNavigationStack } from '../../context/NavigationStackContext';
import { SettingContent } from '../../assets/styles/components/settingsPopover.styled';
import AddEditTransactionHeader from '../dashboard/addTransaction/addEditTransactionHeader';

const LanguageAndRegion = () => {
  const { t } = useTranslation();
  const { setTitle } = usePage();
  const { goBack } = useNavigationStack();

  const handleBack = () => {
    goBack();
  };

  useEffect(() => {
    setTitle(
      <AddEditTransactionHeader
        handleBack={handleBack}
        title={t('common:profile.languageAndRegionalFormat')}
        showMenu
        showSettings
        showHomeWithBackButton={false}
      />,
    );
  }, [t]);

  return (
    <SettingContent
      vertical
      gap={15}
      className="flex-grow overflow-y-auto scroll-page-gutter pb-gutter"
    >
      <Flex vertical gap={10}>
        <Paragraph $fontsize="12px" $color="subtitle" $weight={500} $lineheight="normal">
          {t('common:language')}
        </Paragraph>
        <LanguageList />
      </Flex>
      <Flex vertical gap={10} className="flex-grow">
        <Paragraph $fontsize="12px" $color="subtitle" $weight={500} $lineheight="normal">
          {t('common:profile.regionalFormat')}
        </Paragraph>
        <RegionList />
      </Flex>
    </SettingContent>
  );
};

export default LanguageAndRegion;
